module.exports = __webpack_public_path__ + "03_bob_brown.28a44619.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_bob_brown.png
// module id = ENq+
// module chunks = 0